/*
 * @Descripttion:
 * @version:
 * @Author: yanghui
 * @Date: 2021-09-24 10:45:44
 * @LastEditors: yanghui
 * @LastEditTime: 2021-11-17 17:49:35
 */
import axios from "../../utils/axios";

// 分类管理
export function getList(query) {
    return axios({
        url: "classifyManage/getList",
        method: "get",
        params: query
    });
}
//分类删除
export function deleteClassify(data) {
    return axios({
        url: "classifyManage/delete",
        method: "post",
        data: data
    });
}
// 分类增加
export function addClassify(data) {
    return axios({
        url: "classifyManage/update",
        method: "post",
        data: data
    });
}

// 分类修改
export function updateClassify(data) {
    return axios({
        url: "classifyManage/update",
        method: "post",
        data: data
    });
}

// 所属父级
export function getClassifyRank(query) {
  return axios({
      url: "classifyManage/obtainOne",
      method: "get",
      params: query
  });
}

// 新删除
export function deleteNewApi(data) {
  return axios({
      url: "/classifyManage/delete",
      method: "post",
      data: data
  });
}

// 数据规格字段列表
export function SpecificationsList(query) {
  return axios({
      url: "/classifyManage/getSpecificationsList",
      method: "get",
      params: query
  });
}

// 数据规格字段详情
export function specificationsDetail(query) {
  return axios({
      url: "/classifyManage/getSerchitemById",
      method: "get",
      params: query
  });
}

// 数据规格字段添加/修改
export function specificationsUpdate(data) {
  return axios({
      url: "/classifyManage/specificationsUpdate",
      method: "post",
      data: data
  });
}

// 分类添加/修改 获取数据规格字段列表
export function getSerchitemList() {
  return axios({
      url: "/classifyManage/getSerchitemList",
      method: "get"
  });
}

//分类删除
export function deleteSearchitem(data) {
    return axios({
        url: "classifyManage/deleteSearchitem",
        method: "post",
        data: data
    });
}
